import { handleActions } from 'redux-actions';
import moment from 'moment';

import { types, inputFieldNames } from '../constants';
import { getUniqueArray } from './../utils/attachmentUtils';

const INITIAL_STATE = {
  newHazard: {
    showCreateHazardDialog: false,
    showEditHazardPanel: false,
    showEditHazardDialog: false,
    showHazardReviewPanel: false,
    showHazardManagementLogPanel: false,
    item: {
      lastHeldDateUTC: null,
      nextHazardDateUTC: null,
      attachmentFiles: [],
      existingAttachmentFiles: []
    },
    isSaving: false,
    errorMessage: ''
  },
  hazard: {
    item: null,
    isLoading: false,
    errorMessage: ''
  },
  newControl: {
    item: {
      comments: '',
      attachmentFiles: [],
      existingAttachmentFiles: []
    },
    isSaving: false,
    errorMessage: '',
    openAddHazardControlDialog: false
  },
  controlsForTheHazard: {
    items: [],
    isLoading: false,
    errorMessage: null
  },
  deleteControl: {
    item: {},
    result: false,
    isSaving: false,
    errorMessage: null,
    showDeleteHazardControlDialog: false
  },
  editControl: {
    enable: false,
    item: null,
    isSaving: false,
    errorMessage: '',
    attachmentFiles: [],
    existingAttachmentFiles: []
  },
  reviewsForTheHazard: {
    items: [],
    isLoading: false,
    errorMessage: null
  },
  newReview: {
    item: {
      description: '',
      attachmentFiles: [],
      existingAttachmentFiles: []
    },
    isSaving: false,
    errorMessage: '',
    openAddHazardReviewDialog: false
  },
  editReview: {
    enable: false,
    item: null,
    isSaving: false,
    errorMessage: '',
    openDeleteHazardReviewDialog: false,
    attachmentFiles: [],
    existingAttachmentFiles: []
  },
  toBeDeleteReview: {
    item: {},
    isSaving: false,
    errorMessage: '',
    showDeleteHazardReviewDialog: false
  },
  managementLogsForTheHazard: {
    items: [],
    isLoading: false,
    errorMessage: null
  },
  newManagementLog: {
    item: {
      description: '',
      attachmentFiles: [],
      existingAttachmentFiles: []
    },
    isSaving: false,
    errorMessage: '',
    openAddHazardManagementDialog: false
  },
  editManagementLog: {
    enable: false,
    item: null,
    isSaving: false,
    errorMessage: '',
    openDeleteHazardManagementDialog: false,
    attachmentFiles: [],
    existingAttachmentFiles: []
  },
  toBeDeleteManagementLog: {
    item: {},
    isSaving: false,
    errorMessage: '',
    showDeleteHazardManagementLogDialog: false
  }
};

const openCreateHazardDialog = (state, { open }) => {
  return {
    ...state,
    newHazard: {
      ...state.newHazard,
      showCreateHazardDialog: open,
      item: {
        lastHeldDateUTC: null,
        nextHazardDateUTC: null
      }
    }
  };
};

const openEditHazardPanel = (state, { open }) => {
  return {
    ...state,
    newHazard: {
      ...state.newHazard,
      showEditHazardPanel: open,
      item: {}
    }
  };
};

const openEditHazardDialog = (state, { open }) => {
  return {
    ...state,
    newHazard: {
      ...state.newHazard,
      showEditHazardDialog: open,
      item: {}
    }
  };
};

const inputChangeCreateHazardForm = (state, { value, inputFieldName }) => {
  const hazard = { ...state.newHazard.item };
  const control = { ...state.newControl.item };

  switch (inputFieldName) {
    case inputFieldNames.DESCRIPTION:
      hazard.description = value;
      break;
    case inputFieldNames.FREQUENCY:
      hazard.reviewFrequency = Number(value);
      break;
    case inputFieldNames.INITIAL_RISK_LIKELIHOOD:
      hazard.initialRiskLikelihood = Number(value);
      break;
    case inputFieldNames.INITIAL_RISK_CONSEQUENCE:
      hazard.initialRiskConsequence = Number(value);
      break;
    case inputFieldNames.INITIAL_SCORE:
      hazard.initialScore = Number(value);
      break;
    case inputFieldNames.FINAL_RISK_LIKELIHOOD:
      hazard.finalRiskLikelihood = Number(value);
      break;
    case inputFieldNames.FINAL_RISK_CONSEQUENCE:
      hazard.finalRiskConsequence = Number(value);
      break;
    case inputFieldNames.FINAL_SCORE:
      hazard.finalScore = Number(value);
      break;
    case inputFieldNames.NEXT_REVIEW_DATE:
      var newDate = moment(value).local().format('YYYY-MM-DD');
      hazard.nextReviewDate = newDate;
      break;
    case inputFieldNames.CONTROL_HIERARCHY:
      control.hierarchy = value;
      break;
    case inputFieldNames.CONTROL_COMMENTS:
      control.comments = value;
      break;
    case inputFieldNames.HAZARD_STATUS:
      hazard.status = value;
      break;
    case inputFieldNames.HAZARD_DOCUMENT:
      hazard.document = value;
      break;
    case inputFieldNames.HAZARD_ATTACHMENT:
      if (!hazard.attachmentFiles) {
        hazard.attachmentFiles = [];
      }
      hazard.attachmentFiles.push(value);
      var filteredArray = uniqueArray(hazard.attachmentFiles);
      hazard.attachmentFiles = filteredArray;
      break;
      case inputFieldNames.HAZARD_CONTROL_DOCUMENT:
        control.document = value;
        break;
    case inputFieldNames.HAZARD_CONTROL_ATTACHMENT:
      if (!control.attachmentFiles) {
        control.attachmentFiles = [];
      }
      control.attachmentFiles.push(value);
      var filteredArray = getUniqueArray(control.attachmentFiles);
      control.attachmentFiles = filteredArray;
      break;
      case inputFieldNames.HAZARD_DEPARTMENT:
        hazard.department = value;
    default:
      break;
  }

  return {
    ...state,
    newHazard: {
      ...state.newHazard,
      item: hazard
    },
    newControl: {
      ...state.newControl,
      item: control
    }
  };
};

const startSubmitHazard = (state) => {
  return {
    ...state,
    newHazard: {
      ...state.newHazard,
      isSaving: true
    }
  };
};

const submitHazardSuccess = (state, { submittedHazard }) => {
  return {
    ...state,
    hazard: {
      ...state.hazard,
      item: submittedHazard
    }
  };
};

const submitHazardFailure = (state, { errorMessage }) => {
  return {
    ...state,
    newHazard: {
      ...state.newHazard,
      errorMessage
    }
  };
};

const submitHazardFinished = (state) => {
  return {
    ...state,
    newHazard: {
      ...state.newHazard,
      isSaving: false
    }
  };
};

const editHazard = (state, { hazard }) => {
  return {
    ...state,
    newHazard: {
      ...state.newHazard,
      item: hazard
    }
  };
};

const startFetchControlsForTheHazard = (state) => {
  return {
    ...state,
    controlsForTheHazard: {
      ...state.controlsForTheHazard,
      isLoading: true
    }
  };
};

const fetchControlsForTheHazardSuccess = (state, { controls }) => {
  return {
    ...state,
    controlsForTheHazard: {
      ...state.controlsForTheHazard,
      items: controls
    }
  };
};

const fetchControlsForTheHazardFailure = (state, { errorMessage }) => {
  return {
    ...state,
    controlsForTheHazard: {
      ...state.controlsForTheHazard,
      errorMessage
    }
  };
};

const fetchControlsForTheHazardFinished = (state) => {
  return {
    ...state,
    controlsForTheHazard: {
      ...state.controlsForTheHazard,
      isLoading: false
    }
  };
};

const openHazardControlDeleteDialog = (state, { open, controlId }) => {
  const toDeleteControl = state.controlsForTheHazard.items.filter(
    (r) => r.id === controlId
  )[0];
  const error = open ? state.deleteControl.errorMessage : '';
  return {
    ...state,
    deleteControl: {
      ...state.deleteControl,
      item: toDeleteControl,
      showDeleteHazardControlDialog: open,
      errorMessage: error
    }
  };
};

const startDeleteHazardControl = (state) => {
  return {
    ...state,
    deleteControl: {
      ...state.deleteControl,
      isSaving: true
    }
  };
};

const deleteHazardControlSuccess = (state, { controlId }) => {
  let controls = [...state.controlsForTheHazard.items];
  let deleteIndex = controls.findIndex((r) => r.id === controlId);

  if (deleteIndex !== -1) {
    controls.splice(deleteIndex, 1);
  }

  return {
    ...state,
    deleteControl: {
      ...state.deleteControl
    },
    controlsForTheHazard: {
      ...state.controlsForTheHazard,
      items: controls
    }
  };
};

const deleteHazardControlFailure = (state, { errorMessage }) => {
  return {
    ...state,
    deleteControl: {
      ...state.deleteControl,
      errorMessage
    }
  };
};

const deleteHazardControlFinished = (state) => {
  return {
    ...state,
    deleteControl: {
      ...state.deleteControl,
      item: {},
      isSaving: false
    }
  };
};

const startSubmitHazardControl = (state) => {
  return {
    ...state,
    newControl: {
      ...state.newControl,
      isSaving: true
    }
  };
};

const submitHazardControlSuccess = (state) => {
  return {
    ...state,
    newControl: {
      ...state.newControl,
      item: {
        comments: ''
      }
    }
  };
};

const submitHazardControlFailure = (state, { errorMessage }) => {
  return {
    ...state,
    newControl: {
      ...state.newControl,
      errorMessage
    }
  };
};

const submitHazardControlFinished = (state) => {
  return {
    ...state,
    newControl: {
      ...state.newControl,
      isSaving: false
    }
  };
};

const enableEditHazardControl = (
  state,
  { enableEditControlMode, controlId }
) => {
  const control = state.controlsForTheHazard.items.filter(
    (r) => r.id === controlId
  )[0];

  return {
    ...state,
    editControl: {
      ...state.editControl,
      enable: enableEditControlMode,
      item: control
    }
  };
};

const inputChangeEditHazardControl = (state, { value, inputFieldName }) => {
  const control = { ...state.editControl.item };


  switch (inputFieldName) {
    case inputFieldNames.CONTROL_COMMENTS:
      control.comments = value;
      break;
    case inputFieldNames.CONTROL_NOTES:
      control.notes = value;
      break;
    case inputFieldNames.CONTROL_HIERARCHY:
      control.hierarchy = value;
      break;
      case inputFieldNames.HAZARD_CONTROL_DOCUMENT:
        control.document = value;
        break;
    default:
  }

  return {
    ...state,
    editControl: {
      ...state.editControl,
      item: control
    }
  };
};

const openAddHazardControlDialog = (state, { open }) => {
  return {
    ...state,
    newControl: {
      ...state.newControl,
      openAddHazardControlDialog: open
    }
  };
};

//HAZARD REVIEW

const openHazardReviewPanel = (state, { open }) => {
  return {
    ...state,
    newHazard: {
      ...state.newHazard,
      showHazardReviewPanel: open,
      item: {}
    }
  };
};

const startFetchReviewsForTheHazard = (state) => {
  return {
    ...state,
    reviewsForTheHazard: {
      ...state.reviewsForTheHazard,
      isLoading: true
    }
  };
};

const fetchReviewsForTheHazardSuccess = (state, { reviews }) => {
  return {
    ...state,
    reviewsForTheHazard: {
      ...state.reviewsForTheHazard,
      items: reviews
    }
  };
};

const fetchReviewsForTheHazardFailure = (state, { errorMessage }) => {
  return {
    ...state,
    reviewsForTheHazard: {
      ...state.reviewsForTheHazard,
      errorMessage
    }
  };
};

const fetchReviewsForTheHazardFinished = (state) => {
  return {
    ...state,
    reviewsForTheHazard: {
      ...state.reviewsForTheHazard,
      isLoading: false
    },
    toBeDeleteReview: {
...state.toBeDeleteReview,
      isSaving: false
    }
  };
};

const startSubmitHazardReview = (state) => {
  return {
    ...state,
    newReview: {
      ...state.newReview,
      isSaving: true
    }
  };
};

const submitHazardReviewSuccess = (state, { createdReview }) => {
  return {
    ...state,
    newReview: {
      ...state.newReview,
      item: {
        description: ''
      }
    }
  };
};

const submitHazardReviewFailure = (state, { errorMessage }) => {
  return {
    ...state,
    newReview: {
      ...state.newReview,
      errorMessage
    }
  };
};

const submitHazardReviewFinished = (state) => {
  return {
    ...state,
    newReview: {
      ...state.newReview,
      isSaving: false
    }
  };
};

const enableEditHazardReview = (state, { enableEditReviewMode, reviewId }) => {
  const review = state.reviewsForTheHazard.items.filter(
    (r) => r.id === reviewId
  )[0];

  return {
    ...state,
    editReview: {
      ...state.editReview,
      enable: enableEditReviewMode,
      item: review
    }
  };
};

const openAddHazardReviewDialog = (state, { open }) => {
  return {
    ...state,
    newReview: {
      ...state.newReview,
      openAddHazardReviewDialog: open,
      isSaving: false
    }
  };
};

const inputChangeAddHazardReview = (state, { value, inputFieldName }) => {
  const review = { ...state.newReview.item };

  switch (inputFieldName) {
    case inputFieldNames.REVIEW_DESCRIPION:
      review.description = value;
      break;
    case inputFieldNames.REVIEW_REVIEW_DATE:
      review.reviewDate = value;
      break;
    case inputFieldNames.HAZARD_REVIEW_ATTACHMENT:
      if (!review.attachmentFiles) {
        review.attachmentFiles = [];
      }
      review.attachmentFiles.push(value);
      var filteredArray = getUniqueArray(review.attachmentFiles);
      review.attachmentFiles = filteredArray;
      break;
    default:
  }
  return {
    ...state,
    newReview: {
      ...state.newReview,
      item: review
    }
  };
};

const inputChangeEditHazardReview = (state, { value, inputFieldName }) => {
  const review = { ...state.editReview.item };

  switch (inputFieldName) {
    case inputFieldNames.REVIEW_DESCRIPION:
      review.description = value;
      break;
    case inputFieldNames.REVIEW_REVIEW_DATE:
      review.reviewDate = value;
      break;
    case inputFieldNames.HAZARD_REVIEW_ATTACHMENT:
      if (!review.attachmentFiles) {
        review.attachmentFiles = [];
      }
      review.attachmentFiles.push(value);
      var filteredArray = getUniqueArray(review.attachmentFiles);
      review.attachmentFiles = filteredArray;
      break;
    default:
  }
  return {
    ...state,
    editReview: {
      ...state.editReview,
      item: review
    }
  };
};

const openDeleteHazardReviewDialog = (state, { open, reviewId }) => {
  const review =
    open === true
      ? state.reviewsForTheHazard.items.filter((r) => r.id === reviewId)[0]
      : {};
  return {
    ...state,
    toBeDeleteReview: {
      ...state.toBeDeleteReview,
      item: review,
      showDeleteHazardReviewDialog: open
    }
  };
};

//Hazard Management Logs

const openHazardManagementLogPanel = (state, { open }) => {
  return {
    ...state,
    newHazard: {
      ...state.newHazard,
      showHazardManagementLogPanel: open,
      item: {}
    }
  };
};

const startFetchManagementLogsForTheHazard = (state) => {
  return {
    ...state,
    managementLogsForTheHazard: {
      ...state.managementLogsForTheHazard,
      isLoading: true
    }
  };
};

const fetchManagementLogsForTheHazardSuccess = (state, { managementLogs }) => {
  return {
    ...state,
    managementLogsForTheHazard: {
      ...state.managementLogsForTheHazard,
      items: managementLogs
    }
  };
};

const fetchManagementLogsForTheHazardFailure = (state, { errorMessage }) => {
  return {
    ...state,
    managementLogsForTheHazard: {
      ...state.managementLogsForTheHazard,
      errorMessage
    }
  };
};

const fetchManagementLogsForTheHazardFinished = (state) => {
  return {
    ...state,
    managementLogsForTheHazard: {
      ...state.managementLogsForTheHazard,
      isLoading: false
    }
  };
};

const startSubmitHazardManagementLog = (state) => {
  return {
    ...state,
    newManagementLog: {
      ...state.newManagementLog,
      isSaving: true
    }
  };
};

const submitHazardManagementLogSuccess = (state, { createdManagementLog }) => {
  return {
    ...state,
    newManagementLog: {
      ...state.newManagementLog,
      item: {
        description: ''
      }
    }
  };
};

const submitHazardManagementLogFailure = (state, { errorMessage }) => {
  return {
    ...state,
    newManagementLog: {
      ...state.newManagementLog,
      errorMessage
    }
  };
};

const submitHazardManagementLogFinished = (state) => {
  return {
    ...state,
    newManagementLog: {
      ...state.newManagementLog,
      isSaving: false
    }
  };
};

const enableHazardManagementLog = (
  state,
  { enableEditManagmentLogMode, managementLogId }
) => {
  const managementLog = state.managementLogsForTheHazard.items.filter(
    (r) => r.id === managementLogId
  )[0];
  return {
    ...state,
    editManagementLog: {
      ...state.editManagementLog,
      enable: enableEditManagmentLogMode,
      item: managementLog
    }
  };
};

const openAddHazardManagementLogDialog = (state, { open }) => {
  return {
    ...state,
    newManagementLog: {
      ...state.newManagementLog,
      openAddHazardManagementDialog: open,
      isSaving: false
    }
  };
};

const inputChangeAddHazardManagementLog = (
  state,
  { value, inputFieldName }
) => {
  const managementLog = { ...state.newManagementLog.item };

  switch (inputFieldName) {
    case inputFieldNames.LOG_DESCRIPION:
      managementLog.description = value;
      break;
    case inputFieldNames.LOG_DATE:
      managementLog.logDate = value;
      break;
    case inputFieldNames.HAZARD_MANAGEMENT_LOGS_ATTACHMENT:
      if (!managementLog.attachmentFiles) {
        managementLog.attachmentFiles = [];
      }
      managementLog.attachmentFiles.push(value);
      var filteredArray = getUniqueArray(managementLog.attachmentFiles);
      managementLog.attachmentFiles = filteredArray;
      break;
    default:
  }
  return {
    ...state,
    newManagementLog: {
      ...state.newManagementLog,
      item: managementLog
    }
  };
};

const inputChangeEditHazardManagementLog = (
  state,
  { value, inputFieldName }
) => {
  const managementLog = { ...state.editManagementLog.item };

  switch (inputFieldName) {
    case inputFieldNames.LOG_DESCRIPION:
      managementLog.description = value;
      break;
    case inputFieldNames.LOG_DATE:
      managementLog.logDate = value;
      break;
    case inputFieldNames.HAZARD_MANAGEMENT_LOGS_ATTACHMENT:
      if (!managementLog.attachmentFiles) {
        managementLog.attachmentFiles = [];
      }
      managementLog.attachmentFiles.push(value);
      var filteredArray = getUniqueArray(managementLog.attachmentFiles);
      managementLog.attachmentFiles = filteredArray;
      break;
    default:
  }
  return {
    ...state,
    editManagementLog: {
      ...state.editManagementLog,
      item: managementLog
    }
  };
};

const openDeleteHazardManagementLogDialog = (
  state,
  { open, managementLogId }
) => {
  const managementLog =
    open === true
      ? state.managementLogsForTheHazard.items.filter(
          (r) => r.id === managementLogId
        )[0]
      : {};
  return {
    ...state,
    toBeDeleteManagementLog: {
      ...state.toBeDeleteManagementLog,
      item: managementLog,
      showDeleteHazardManagementLogDialog: open
    }
  };
};

//Attachments
const removeAttachment = (state, { attachment }) => {
  let hazard = state.newHazard.item;
  let remainingAttachements = hazard.attachmentFiles.filter(
    (item) => item.name !== attachment.name
  );
  hazard.attachmentFiles = remainingAttachements;
  return {
    ...state,
    newHazard: {
      ...state.newHazard,
      item: hazard
    }
  };
};

const startLoadAttachmentsForHazard = (state) => {
  return {
    ...state,
    newHazard: {
      ...state.newHazard,
      isSaving: true
    }
  };
};

const loadAttachmentsForHazardSuccess = (state, { attachments }) => {
  var attachmentCustomObjets = [];

  for (let index = 0; index < attachments.length; index++) {
    const element = {
      id: attachments[index].id,
      newlyAdded: false,
      removed: false,
      fileData: null,
      name: attachments[index].fileName,
      url: attachments[index].url
    };
    attachmentCustomObjets.push(element);
  }

  return {
    ...state,
    newHazard: {
      ...state.newHazard,
      item: {
        ...state.newHazard.item,
        attachmentFiles: attachmentCustomObjets,
        existingAttachmentFiles: attachmentCustomObjets
      }
    }
  };
};

const loadAttachmentForHazardFailure = (state, { errorMessage }) => {
  return {
    ...state,
    newHazard: {
      ...state.newHazard,
      errorMessage
    }
  };
};

const loadAttachmentForHazardFinished = (state, { errorMessage }) => {
  return {
    ...state,
    newHazard: {
      ...state.newHazard,
      isSaving: false
    }
  };
};

//Review Attachment
const startLoadAttachmentsForHazardReview = (state) => {
  return {
    ...state,
    editReview: {
      ...state.editReview,
      isSaving: true
    }
  };
};

const loadAttachmentsForHazardReviewSuccess = (state, { attachments }) => {
  var attachmentCustomObjets = [];

  for (let index = 0; index < attachments.length; index++) {
    const element = {
      id: attachments[index].id,
      newlyAdded: false,
      removed: false,
      fileData: null,
      name: attachments[index].fileName,
      url: attachments[index].url
    };
    attachmentCustomObjets.push(element);
  }

  return {
    ...state,
    editReview: {
      ...state.editReview,
      item: {
        ...state.editReview.item,
        attachmentFiles: attachmentCustomObjets,
        existingAttachmentFiles: attachmentCustomObjets
      }
    }
  };
};

const loadAttachmentForHazardReviewFailure = (state, { errorMessage }) => {
  return {
    ...state,
    editReview: {
      ...state.editReview,
      errorMessage
    }
  };
};

const loadAttachmentForHazardReviewFinished = (state, { errorMessage }) => {
  return {
    ...state,
    editReview: {
      ...state.editReview,
      isSaving: false
    }
  };
};

const removeReviewAttachment = (state, { attachment }) => {
  let review = state.newReview.item;
  let remainingAttachements = review.attachmentFiles.filter(
    (item) => item.name !== attachment.name
  );
  review.attachmentFiles = remainingAttachements;
  return {
    ...state,
    newReview: {
      ...state.newReview,
      item: review
    }
  };
};

const removeAttachmentFromEditReviewMode = (state, { attachment }) => {
  let review = state.editReview.item;
  let remainingAttachements = review.attachmentFiles.filter(
    (item) => item.name !== attachment.name
  );
  review.attachmentFiles = remainingAttachements;
  return {
    ...state,
    editReview: {
      ...state.editReview,
      item: review
    }
  };
};

//Attachment Management Logs
const startLoadAttachmentsForManagementLogs = (state) => {
  return {
    ...state,
    editManagementLog: {
      ...state.editManagementLog,
      isSaving: true
    }
  };
};

const loadAttachmentsForManagementLogsSuccess = (state, { attachments }) => {
  var attachmentCustomObjets = [];

  for (let index = 0; index < attachments.length; index++) {
    const element = {
      id: attachments[index].id,
      newlyAdded: false,
      removed: false,
      fileData: null,
      name: attachments[index].fileName,
      url: attachments[index].url
    };
    attachmentCustomObjets.push(element);
  }

  return {
    ...state,
    editManagementLog: {
      ...state.editManagementLog,
      item: {
        ...state.editManagementLog.item,
        attachmentFiles: attachmentCustomObjets,
        existingAttachmentFiles: attachmentCustomObjets
      }
    }
  };
};

const loadAttachmentForManagementLogsFailure = (state, { errorMessage }) => {
  return {
    ...state,
    editManagementLog: {
      ...state.editManagementLog,
      errorMessage
    }
  };
};

const loadAttachmentForManagementLogsFinished = (state, { errorMessage }) => {
  return {
    ...state,
    editManagementLog: {
      ...state.editManagementLog,
      isSaving: false
    }
  };
};

const removeManagementLogsAttachment = (state, { attachment }) => {
  let managementLogs = state.newManagementLog.item;
  let remainingAttachements = managementLogs.attachmentFiles.filter(
    (item) => item.name !== attachment.name
  );
  managementLogs.attachmentFiles = remainingAttachements;
  return {
    ...state,
    newManagementLog: {
      ...state.newManagementLog,
      item: managementLogs
    }
  };
};

const removeAttachmentFromEditManagementLogMode = (state, { attachment }) => {
  let managementLog = state.editManagementLog.item;
  let remainingAttachements = managementLog.attachmentFiles.filter(
    (item) => item.name !== attachment.name
  );
  managementLog.attachmentFiles = remainingAttachements;
  return {
    ...state,
    editManagementLog: {
      ...state.editManagementLog,
      item: managementLog
    }
  };
};

//Control Attachment
const startLoadAttachmentsForHazardControl = (state) => {
  return {
    ...state,
    editControl: {
      ...state.editControl,
      isSaving: true
    }
  };
};

const loadAttachmentsForHazardControlSuccess = (state, { attachments }) => {
  var attachmentCustomObjets = [];

  for (let index = 0; index < attachments.length; index++) {
    const element = {
      id: attachments[index].id,
      newlyAdded: false,
      removed: false,
      fileData: null,
      name: attachments[index].fileName,
      url: attachments[index].url
    };
    attachmentCustomObjets.push(element);
  }

  return {
    ...state,
    editControl: {
      ...state.editControl,
      item: {
        ...state.editControl.item,
        attachmentFiles: attachmentCustomObjets,
        existingAttachmentFiles: attachmentCustomObjets
      }
    }
  };
};

const loadAttachmentForHazardControlFailure = (state, { errorMessage }) => {
  return {
    ...state,
    editControl: {
      ...state.editControl,
      errorMessage
    }
  };
};

const loadAttachmentForHazardControlFinished = (state, { errorMessage }) => {
  return {
    ...state,
    editControl: {
      ...state.editControl,
      isSaving: false
    }
  };
};

const removeControlAttachment = (state, { attachment }) => {
  let control = state.newControl.item;
  let remainingAttachements = control.attachmentFiles.filter(
    (item) => item.name !== attachment.name
  );
  control.attachmentFiles = remainingAttachements;
  return {
    ...state,
    newControl: {
      ...state.newControl,
      item: control
    }
  };
};

const removeAttachmentFromEditControlMode = (state, { attachment }) => {
  let control = state.editControl.item;
  let remainingAttachements = control.attachmentFiles.filter(
    (item) => item.name !== attachment.name
  );
  control.attachmentFiles = remainingAttachements;
  return {
    ...state,
    editControl: {
      ...state.editControl,
      item: control
    }
  };
};

const uniqueArray = (mixedArray) => {
  let newArray = [];
  let uniqueObject = {};
  for (let i in mixedArray) {
    let objTitle = mixedArray[i]['name'];
    uniqueObject[objTitle] = mixedArray[i];
  }
  for (let i in uniqueObject) {
    newArray.push(uniqueObject[i]);
  }
  return newArray;
};

//Handles the incoming actions.
export default handleActions(
  {
    [types.OPEN_CREATE_HAZARD_DIALOG]: openCreateHazardDialog,
    [types.OPEN_EDIT_HAZARD_PANEL]: openEditHazardPanel,
    [types.OPEN_EDIT_HAZARD_DIALOG]: openEditHazardDialog,
    [types.INPUT_CHANGE_CREATE_HAZARD_FORM]: inputChangeCreateHazardForm,

    [types.START_SUBMIT_HAZARD]: startSubmitHazard,
    [types.SUBMIT_HAZARD_SUCCESS]: submitHazardSuccess,
    [types.SUBMIT_HAZARD_FAILURE]: submitHazardFailure,
    [types.SUBMIT_HAZARD_FINISHED]: submitHazardFinished,

    [types.EDIT_HAZARD]: editHazard,

    [types.START_FETCH_CONTROLS_FOR_THE_HAZARD]: startFetchControlsForTheHazard,
    [types.FETCH_CONTROLS_FOR_THE_HAZARD_SUCCESS]: fetchControlsForTheHazardSuccess,
    [types.FETCH_CONTROLS_FOR_THE_HAZARD_FAILURE]: fetchControlsForTheHazardFailure,
    [types.FETCH_CONTROLS_FOR_THE_HAZARD_FINISHED]: fetchControlsForTheHazardFinished,

    [types.OPEN_DELETE_HAZARD_CONTROL_DIALOG]: openHazardControlDeleteDialog,

    [types.START_DELETE_HAZARD_CONTROL]: startDeleteHazardControl,
    [types.DELETE_HAZARD_CONTROL_SUCCESS]: deleteHazardControlSuccess,
    [types.DELETE_HAZARD_CONTROL_FAILURE]: deleteHazardControlFailure,
    [types.DELETE_HAZARD_CONTROL_FINISHED]: deleteHazardControlFinished,

    [types.START_SUBMIT_HAZARD_CONTROL]: startSubmitHazardControl,
    [types.SUBMIT_HAZARD_CONTROL_SUCCESS]: submitHazardControlSuccess,
    [types.SUBMIT_HAZARD_CONTROL_FAILURE]: submitHazardControlFailure,
    [types.SUBMIT_HAZARD_CONTROL_FINISHED]: submitHazardControlFinished,

    [types.ENABLE_EDIT_HAZARD_CONTROL]: enableEditHazardControl,

    [types.INPUT_CHANGE_EDIT_HAZARD_CONTROL]: inputChangeEditHazardControl,

    [types.OPEN_ADD_HAZARD_CONTROL_DIALOG]: openAddHazardControlDialog,

    //Hazard Review
    [types.OPEN_HAZARD_REVIEW_PANEL]: openHazardReviewPanel,

    [types.START_FETCH_REVIEWS_FOR_THE_HAZARD]: startFetchReviewsForTheHazard,
    [types.FETCH_REVIEWS_FOR_THE_HAZARD_SUCCESS]: fetchReviewsForTheHazardSuccess,
    [types.FETCH_REVIEWS_FOR_THE_HAZARD_FAILURE]: fetchReviewsForTheHazardFailure,
    [types.FETCH_REVIEWS_FOR_THE_HAZARD_FINISHED]: fetchReviewsForTheHazardFinished,

    [types.OPEN_CREATE_HAZARD_REVIEW_DIALOG]: openAddHazardReviewDialog,

    [types.START_SUBMIT_HAZARD_REVIEW]: startSubmitHazardReview,
    [types.SUBMIT_HAZARD_REVIEW_SUCCESS]: submitHazardReviewSuccess,
    [types.SUBMIT_HAZARD_Review_FAILURE]: submitHazardReviewFailure,
    [types.SUBMIT_HAZARD_Review_FINISHED]: submitHazardReviewFinished,

    [types.INPUT_CHANGE_ADD_HAZARD_REVIEW]: inputChangeAddHazardReview,
    [types.INPUT_CHANGE_EDIT_HAZARD_REVIEW]: inputChangeEditHazardReview,

    [types.ENABLE_EDIT_HAZARD_REVIEW]: enableEditHazardReview,
    [types.OPEN_DELETE_HAZARD_REVIEW_DIALOG]: openDeleteHazardReviewDialog,

    //Hazard Management Log
    [types.OPEN_HAZARD_MANAGEMENTLOG_PANEL]: openHazardManagementLogPanel,

    [types.START_FETCH_MANAGEMENT_LOGS_FOR_THE_HAZARD]: startFetchManagementLogsForTheHazard,
    [types.FETCH_MANAGEMENT_LOGS_FOR_THE_HAZARD_SUCCESS]: fetchManagementLogsForTheHazardSuccess,
    [types.FETCH_MANAGEMENT_LOGS_FOR_THE_HAZARD_FAILURE]: fetchManagementLogsForTheHazardFailure,
    [types.FETCH_MANAGEMENT_LOGS_FOR_THE_HAZARD_FINISHED]: fetchManagementLogsForTheHazardFinished,

    [types.OPEN_CREATE_HAZARD_MANAGEMENT_LOG_DIALOG]: openAddHazardManagementLogDialog,

    [types.START_SUBMIT_HAZARD_MANAGEMENT_LOG]: startSubmitHazardManagementLog,
    [types.SUBMIT_HAZARD_MANAGEMENT_LOG_SUCCESS]: submitHazardManagementLogSuccess,
    [types.SUBMIT_HAZARD_MANAGEMENT_LOG_FAILURE]: submitHazardManagementLogFailure,
    [types.SUBMIT_HAZARD_MANAGEMENT_LOG_FINISHED]: submitHazardManagementLogFinished,

    [types.INPUT_CHANGE_ADD_HAZARD_MANAGEMENT_LOG]: inputChangeAddHazardManagementLog,
    [types.INPUT_CHANGE_EDIT_HAZARD_MANAGEMENT_LOG]: inputChangeEditHazardManagementLog,

    [types.ENABLE_EDIT_HAZARD_MANAGEMENT_LOG]: enableHazardManagementLog,
    [types.OPEN_DELETE_HAZARD_MANAGEMENT_LOG_DIALOG]: openDeleteHazardManagementLogDialog,

    [types.START_LOAD_ATTACHMENTS_FOR_HAZARD]: startLoadAttachmentsForHazard,
    [types.LOAD_ATTACHMENTS_FOR_HAZARD_SUCCESS]: loadAttachmentsForHazardSuccess,
    [types.LOAD_ATTACHMENTS_FOR_HAZARD_FAILURE]: loadAttachmentForHazardFailure,
    [types.LOAD_ATTACHMENTS_FOR_HAZARD_FINISHED]: loadAttachmentForHazardFinished,

    [types.REMOVE_HAZARD_ATTACHMENT]: removeAttachment,

    //Hazard Review Attachement
    [types.START_LOAD_ATTACHMENTS_FOR_HAZARD_REVIEW]: startLoadAttachmentsForHazardReview,
    [types.LOAD_ATTACHMENTS_FOR_HAZARD_REVIEW_SUCCESS]: loadAttachmentsForHazardReviewSuccess,
    [types.LOAD_ATTACHMENTS_FOR_HAZARD_REVIEW_FAILURE]: loadAttachmentForHazardReviewFailure,
    [types.LOAD_ATTACHMENTS_FOR_HAZARD_REVIEW_FINISHED]: loadAttachmentForHazardReviewFinished,

    [types.REMOVE_HAZARD_REVIEW_ATTACHMENT]: removeReviewAttachment,
    [types.REMOVE_HAZARD_REVIEW_ATTACHMENT_EDIT]: removeAttachmentFromEditReviewMode,

    //Hazard Management Logs Attachement
    [types.START_LOAD_ATTACHMENTS_FOR_HAZARD_MANAGEMENT_LOGS]: startLoadAttachmentsForManagementLogs,
    [types.LOAD_ATTACHMENTS_FOR_HAZARD_MANAGEMENT_LOGS_SUCCESS]: loadAttachmentsForManagementLogsSuccess,
    [types.LOAD_ATTACHMENTS_FOR_HAZARD_MANAGEMENT_LOGS_FAILURE]: loadAttachmentForManagementLogsFailure,
    [types.LOAD_ATTACHMENTS_FOR_HAZARD_MANAGEMENT_LOGS_FINISHED]: loadAttachmentForManagementLogsFinished,

    [types.REMOVE_HAZARD_MANAGEMENT_LOGS_ATTACHMENT]: removeManagementLogsAttachment,
    [types.REMOVE_HAZARD_MANAGE_LOGS_ATTACHMENT_EDIT]: removeAttachmentFromEditManagementLogMode,

    //Hazard Control Attachement
    [types.START_LOAD_ATTACHMENTS_FOR_HAZARD_CONTROL]: startLoadAttachmentsForHazardControl,
    [types.LOAD_ATTACHMENTS_FOR_HAZARD_CONTROL_SUCCESS]: loadAttachmentsForHazardControlSuccess,
    [types.LOAD_ATTACHMENTS_FOR_HAZARD_CONTROL_FAILURE]: loadAttachmentForHazardControlFailure,
    [types.LOAD_ATTACHMENTS_FOR_HAZARD_CONTROL_FINISHED]: loadAttachmentForHazardControlFinished,

    [types.REMOVE_HAZARD_CONTROL_ATTACHMENT]: removeControlAttachment,
    [types.REMOVE_HAZARD_CONTROL_ATTACHMENT_EDIT]: removeAttachmentFromEditControlMode
  },
  INITIAL_STATE
);
